const changeLogin = (state = true, action) => {
  if (action.type == "loginFalse") {
    return action.payLoad;
  } else {
    return state;
  }
};
export default changeLogin;
